import { render } from "./FaceIdUsersTable.vue?vue&type=template&id=22c941f6"
import script from "./FaceIdUsersTable.vue?vue&type=script&lang=js"
export * from "./FaceIdUsersTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__